module.exports = __webpack_public_path__ + "static/media/microsoft.31bf323e.png";